// src/CustomReport.js
import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";

const CustomReport = () => {
  const [reportData, setReportData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchReportData = async () => {
      try {
        console.log("🔍 Fetching report data from /report-source-data...");

        // ✅ Retrieve stored token
        const token = localStorage.getItem("token");

        if (!token) {
          console.error("❌ No authentication token found.");
          setLoading(false);
          return;
        }

        // ✅ API URL with required query parameters
        const apiUrl = `${process.env.REACT_APP_API_URL}/report-source-data?start_date=2020-01-01&end_date=2030-01-01&token=${token}&nocache=${Date.now()}`;

        console.log(`📡 API Request: ${apiUrl}`);

        // ✅ Include Authorization header
        const response = await fetch(apiUrl, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const rawData = await response.json();
        console.log("✅ Raw Report Data:", rawData);

        // ✅ Corrected Grouping Logic - Using a Map to Ensure All Groomers Appear
        const groupedData = new Map();

        rawData.forEach((row) => {
          const groomer = row.Groomer || "Unknown";
          if (!groupedData.has(groomer)) {
            groupedData.set(groomer, {
              Groomer: groomer,
              Collected_Service_Price: 0,
              Num_Pets: 0,
            });
          }

          // ✅ Properly accumulate values
          const entry = groupedData.get(groomer);
          entry.Collected_Service_Price += parseFloat(row.Collected_Service_Price || 0);
          entry.Num_Pets += parseInt(row.Num_Pets || 0, 10);
        });

        // ✅ Convert Map to an array for display
        const groupedArray = Array.from(groupedData.values());
        console.log("✅ Grouped Report Data:", groupedArray);

        setReportData(groupedArray); // ✅ Should now show all Groomers
        setLoading(false);
      } catch (error) {
        console.error("❌ Error fetching report data:", error);
        setLoading(false);
      }
    };

    fetchReportData();
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Custom Groomer Report
      </Typography>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Groomer</strong></TableCell>
                <TableCell align="right"><strong>Total Service Price</strong></TableCell>
                <TableCell align="right"><strong>Total Pets</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {reportData.map((row, index) => (
                <TableRow key={index}>
                  <TableCell>{row.Groomer}</TableCell>
                  <TableCell align="right">${row.Collected_Service_Price.toFixed(2)}</TableCell>
                  <TableCell align="right">{row.Num_Pets}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default CustomReport;
